import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c9951c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }

import filterEstimationFormComponent from "@/components/filterForm/filterEstimationForm.component.vue";
import samplingPointImageComponent from "@/components/samplingPoints/SamplingPointImage.component.vue";
import observerComponent from "@/components/Observer.component.vue";

import {
  getDistinctLevelsImage,
  getSamplingPointImages,
  updateExpertLevel,
} from "@/service/image.service";
import ElMessage from "element-plus/lib/components/message";
import { reactive, ref, watch } from "vue";
import { Image } from "@/types/Image.type";
import { useI18n } from "vue-i18n";
import { FilterForm } from "@/types/filterForm.type";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const hasMore = ref(false);
const formCmp = ref<InstanceType<typeof filterEstimationFormComponent> | null>(null);
let imagesList = ref<Image[]>([]);
const optionsLevel = ref<Array<{ label: string; value: string }>>([]);
const currentPage = ref(0);
const successAction = "success.action";

const updateExpert = (image: Image) => {
  updateExpertLevel(image)
    .then(() => {
      ElMessage.success(t(successAction));
    })
    .catch(() => {
      ElMessage.error("Error");
    });
};

const searchImages = async (filterEstimation: FilterForm) => {
  console.log("searchImages");
  if (filterEstimation.date[0] && filterEstimation.date[1] && filterEstimation.samplingPointId) {
    const rowPerPage = 10;
    try {
      const { data, totalRows } = await getSamplingPointImages(
        `${filterEstimation.samplingPointId}`,
        1, // Reiniciamos la página a 1 al realizar una nueva búsqueda
        rowPerPage,
        new Date(filterEstimation.date[0]).toISOString(),
        new Date(filterEstimation.date[1]).toISOString()
      );

      imagesList.value = [];

      imagesList.value = [...data]; // Reemplaza las imágenes existentes con las de la búsqueda

      currentPage.value = 2; // Actualiza la página actual

      if (totalRows <= rowPerPage) {
        hasMore.value = false;
      } else {
        hasMore.value = true;
        showMoreSearch();
      }
    } catch (error) {
      hasMore.value = false;
      ElMessage.warning(t("No hay imágenes para este rango seleccionado"));
    }
  } else {
    console.log("searchImages quitar galería");
    imagesList.value = [];
  }

  if (filterEstimation.samplingPointId) {
    const levels = await getDistinctLevelsImage(filterEstimation.samplingPointId);
    optionsLevel.value = levels.map((_) => {
      return {
        label: _,
        value: _ === "Sin valor" ? "Sin valor" : _,
      };
    });
  }
};

const showMoreSearch = async () => {
  if (
    formCmp.value?.filterEstimation.date[0] &&
    formCmp.value?.filterEstimation.date[1] &&
    formCmp.value?.filterEstimation.samplingPointId
  ) {
    const fromDate = formCmp.value?.filterEstimation.date[0];
    const toDate = formCmp.value?.filterEstimation.date[1];
    const rowPerPage = 10;

    const { data, totalRows } = await getSamplingPointImages(
      `${formCmp.value?.filterEstimation.samplingPointId}`,
      currentPage.value,
      rowPerPage,
      new Date(fromDate).toISOString(),
      new Date(toDate).toISOString()
    );

    //Comprobamos que los datos que llegan son mayores que 0 y que no son undefined para que no haya errores
    if (data !== undefined && data.length > 0) {
      currentPage.value++;
      imagesList.value = [...imagesList.value, ...data];
    }

    if (totalRows <= (currentPage.value - 1) * rowPerPage) {
      hasMore.value = false;
    }

    if (imagesList.value.length < rowPerPage && data !== undefined) {
      showMoreSearch();
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "app-main-full-height-lg-and-up" }, {
              default: _withCtx(() => [
                _createVNode(filterEstimationFormComponent, {
                  ref_key: "formCmp",
                  ref: formCmp,
                  showResults: searchImages
                }, null, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 18 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "app-main-full-height-lg-and-up" }, {
              default: _withCtx(() => [
                _createVNode(samplingPointImageComponent, {
                  class: "gallery",
                  ref: "imageModal",
                  edit: true,
                  options: optionsLevel.value,
                  images: _unref(imagesList),
                  functionBtn: updateExpert
                }, null, 8, ["options", "images"]),
                (hasMore.value)
                  ? (_openBlock(), _createBlock(observerComponent, {
                      key: 0,
                      onIntersect: showMoreSearch
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})